
window.PubController = class {
	constructor(pub_id, options = {}) {
		this.pub_id = pub_id;
		this.tpl = $('#page');
		this.options = options;
	}

	initialized = false;

	async init() {

		if(this.initialized) {
			return;
		}
		this.initialized = true;

		// Bind de los triggers
		this.tpl.on('click', '[data-trigger]', async(event) => {
			const target = event.currentTarget;
			target.disabled = true;
			let stopPropagation = true;
			let laddaButton = null;

			// Por default se hace un stop propagation
			// A menos que se defina el atributo data-allow-propagation
			// O que se haya disparado por el track event y no tenga un trigger
			if(target.dataset.allowPropagation !== undefined) {
				stopPropagation = false;
			}

			// Si es tipo button inicializar Ladda
			if(target.tagName === 'BUTTON') {
				if(!target.dataset.style) {
					target.dataset.style = 'zoom-out';
				}
				laddaButton = Ladda.create(target);
			}

			try {
				switch(target.dataset.trigger) {
					case 'Pub.complain':
						laddaButton?.start();
						await this.complain();
						break;

					case 'Gallery.delete':
						laddaButton?.start();
						await this.deleteGallery(target);

					case "XP.delete":
						laddaButton?.start();
						await Library.load(['XpComponent']);
						await XpComponent.delete(target);
						break;

					case "XP.validate":
						laddaButton?.start();
						await Library.load(['XpComponent']);
						await XpComponent.validate(target);
						break;

					case "XP.send":
						laddaButton?.start();
						await Library.load(['XpComponent']);
						await XpComponent.send(target);
						break;

					//	Si ningun trigger matcheo, no hacer stopPropagation
					default:
						stopPropagation = false;
						break;
				}
			} catch (error) {
				ErrorHandler.log(error);
			} finally {

				if(stopPropagation) {
					event.stopPropagation();
				}

				target.disabled = false;
				laddaButton?.stop();
			}


		});

		// init binds
		this.initAbout();

		// init stories

		this.initStories();

		this.initGallery();

		this.initGalleryFilter();

		if(navigator.share) {
			this.tpl.find('button[role="share"]').removeClass('d-none');
			this.tpl.find('button[role="share"]').on('click', this.handleShareEvent );
		}

		this.initMap();

		this.initFavCounter();

		this.toggleXpEntries()
		this.bindXpFilter();

		this.postSelector();
		this.infinityScrollPosts();
	}

	initGalleryFilter() {
		const self = this;

		// init filter gallery
		self.tpl.find("#gallery-filter").find('button').on('click', function(e) {
			e.preventDefault();

			if($(this).is('.btn-outline')) {

				$(this).parent().find('button').addClass('btn-outline');
				$(this).removeClass('btn-outline');

				self.tpl.find('.pub-book-item').addClass('d-none');

				switch($(this).attr('data-target')) {
					case 'photo':
					case 'video' :
						self.tpl.find(`.pub-book-item[data-media_type="${$(this).attr('data-target')}"]`).removeClass('d-none');
						break;
					case 'verified':
						self.tpl.find(`.pub-book-item[data-media_verified="1"]`).removeClass('d-none');
						break;
				}
			}
			else {
				$(this).parent().find('button').addClass('btn-outline');
				self.tpl.find('.pub-book-item').removeClass('d-none');
			}

			self.initGallery();
		});
	}

	/**
	 * Inicializar la Galeria
	 */
	galleryFirstRun = true;
	initGallery() {
		const self = this;
		let gallery_content_prev = null;

		self.tpl.find('.pub-book-item:not(.d-none) a.pub-book-link')
			.magnificPopup({
				mainClass: 'fade show',
				type: 'inline',
				gallery:{
					enabled:true
				},
				//preloader: false,
				callbacks: {
					open: function() {
						$('.mfp-container').addClass('mfp-image-holder').removeClass('mfp-inline-holder');
						$(".mfp-container").swipe({
							swipeLeft: function(event, direction, distance, duration, fingerCount) {
								console.log('left');
								$.magnificPopup.instance.next();
							},
							swipeRight: function(event, direction, distance, duration, fingerCount) {
								console.log('right');
								$.magnificPopup.instance.prev();
							},
						});
					},
					// si tiene un video, lo pauso.
					beforeClose: function() {
						console.log('beforeClose');
						let vid = $('.mfp-container').find('video');
						if( vid.length > 0) {
							vid[0].pause();
						}
					},
					afterClose: function() {
						// Dot removes the entire query string; you may want to rewrite this to
						// remove only necessary parts of the query string
						if(location.search.length) {
							let query = location.toString().replace(location.search, "");
							window.history.pushState({query: query}, '', query);
						}
					},

					change: function(item) {

						let self = this;

						if(gallery_content_prev != null){
							let vid = gallery_content_prev.find('video');
							if( vid.length )
								vid[0].pause();
						}
						gallery_content_prev = this.content;

						let player = self.content[0].querySelector('video');
						let index = self.index;

						if( player ) {
							player.preload = "auto";
							if( player.readyState >= 2 ) {
								player.play();
							}
							else {
								player.load();
								player.onloadeddata = (event) => {
									if(player.readyState >= 2 && index == $.magnificPopup.instance.index) {
										player.play();
									}
								};
							}
						}

						//var state = window.history.getState();
						let $el =  $(item.el);
						let data = $el.parent().data();

						let query =`?m=${data.media_id}.${data.media_type == 'photo'? 'jpg' : 'mp4'}`;

						// Do not clutter user's history: if user just opened the gallery,
						// push the new state, otherwise rewrite the state.
						// Also, if user opened the page
						if (location.search.length) {
							window.history.replaceState({ query: query, plugin: 'mpf', media_id: data.media_id }, '', query);
						} else {
							window.history.pushState({ query: query, plugin: 'mpf', media_id: data.media_id }, '', query);
						}
					} // change
				}
			});


		// Ejecutar una sola vez
		if(self.galleryFirstRun) {

			self.galleryFirstRun = false;

			// Si el usuario hace history back, cargar la imagen de la galeria si correspondiera)
			window.onpopstate = function(event) {
				console.log(event.state);
				if( event.state && event.state.plugin && event.state.plugin == 'mpf' ) {
					$(`a.pub-book-link[href="#media-${event.state.media_id}"]`).click();
				} else {
					$.magnificPopup.close();
				}
			};

			// Si la url apunta a una imagen de la galeria, abrir la galeria en la imagen correspondiente.
			var params = new URLSearchParams(window.location.search)
			for (const [key, value] of params) {
				if(key == "m") {
					$(`a.pub-book-link[href="#media-${value.slice(0, -4)}"]`).click();
				}
			}
		}
	}

	async deleteGallery(target) {
		const self = this;

		const data = target.dataset;
		var $item = $(target).closest('.pub-book-item');

		try {
			const response = await axios.delete(`/api/profile/media/${data.media_id}`);
			$item.remove();
			self.initGallery();

		} catch (error) {
			ErrorHandler.process(error);
		}
	}

	initStories() {
		// Inicializar las historias
		const $storyElements = this.tpl.find('.listing-type-story');
		for(const storyElement of $storyElements) {
			new StoryComponent(storyElement);
		}

	}

	handleShareEvent = (e) => {
		e.preventDefault();
		if (navigator.share) {
			navigator.share({
				title: this.options.head_title ?? '',
				url: window.location.href,
			}).then(() => {
				console.log('Thanks for sharing!');
			})
			.catch(console.error);
		}
	}

	initMap() {
		const self = this;
		let map = self.tpl.find('iframe.map');
		if( map.length ) {
			map.attr('src', map.attr('data-src'));
		}
	}

	initAbout() {
		const self = this;

		self.tpl.find('a[role="show-full-about"]').on('click', function(e) {
			e.preventDefault();
			self.tpl.find('.pub-about-preview').addClass('d-none');
			self.tpl.find('.pub-about-full').removeClass('d-none');
		});
	}

	// Modifica el contador de follow,likes en base a los clicks. No es necesariamente un valor 100% real.
	initFavCounter() {
		const self = this;
		const $favDropdown = self.tpl.find('#favDropdown');
		if ($favDropdown.length) {
			FavListHelper.load('like');

			if (FavListHelper.checked('like', '{{pub.pub_id}}')) {
				$favDropdown.find('#favDropdownIcon').addClass('font-weight-800');
			}

			$favDropdown.on('click', async function() {
				$(this).next().children().each(function() {
					let $el = $(this);
					$el.data('list_status', FavListHelper.checked($el.data('list_type'), $el.data('pub_id')) ? "1" : "0");
				});
			});
		}
	}

	/**
	 * Cierra y abre las entradas de XP
	 */
	toggleXpEntries() {
		this.tpl.find('.comment-xp').on('click', (event) => {
			$(event.currentTarget).toggleClass('open');
		});
	}

	/**
	 * Selector de XP - Filtrado de pubowner para ver las publicadas, pendientes, borradas
	 */
	bindXpFilter() {
		this.tpl.find("#pubXPViewSelector").on('change', async () => {
			let res = await axios.get(`${NOW.settings.url_api}/xp/${self.pub_id}/${$(this).val()}`);
			const $container = this.tpl.find('#xps-container');
			$container.before(res.data.html);
			$container.remove();
		});

	}


	/**
	 * Abre el modal para enviar una denuncia
	 */
	async complain() {
		const self = this;
		const modal = new ModalUi();

		let [$modal] = await Promise.all([
			modal.loadFromServer('complain', {}),
		]);
		modal.render();

		$modal.find('form').on('submit', async function(e) {

			e.preventDefault();
			let form = new FormHandler(e.target);
			if( form.lock() ) return false;

			try {
				let res = await axios.post(`${NOW.settings.url_api}/complain/${self.pub_id}`, form.serialize() );
				await AlertUi.confirm({
					'title': '',
					'msg': res.data.message,
					'type': 'OK',
				});
				modal.hide();

			} catch(err) {

				AlertUi.confirm({
					'title': 'Oops',
					'msg': err?.response?.data?.message || err,
					'type': 'OK',
				});
			}
			// finalizo animacion y libero boton
			form.unlock();
		});
	}


	postSelector() {
		const self = this;

		self.tpl.find("#pubPostViewSelector").on('change', async function() {
			let res = await axios.get(`${NOW.settings.url_api}/pub/${self.pub_id}/posts`, {
				params: {
					from: 0,
					view: $(this).val(),
				}
			});
			const $container = self.tpl.find('#posts-container');
			$container.before(res.data.html);
			$container.remove();

			self.infinityScrollPosts();
		});
	}

	infinityScrollPosts() {
		const self = this;

		let options = {
			root: null,               // Usar el viewport
			rootMargin: '0px 0px 500px 0px',  // Aumenta el área de intersección en 300px en la parte inferior
			threshold: 0              // El callback se dispara tan pronto como incluso un pixel del elemento está en el área de intersección
		};

		let observer = new IntersectionObserver(async (entries, observer) => {
			for(let entry of entries) {
				let pagination = entry.target;

				// Ver si hay interseccion y que no se encuentre solicitando nueva data
				if(entry.isIntersecting && pagination.dataset.loading != true) {

					pagination.dataset.loading = true;

					const res = await axios.get(`${NOW.settings.url_api}/pub/${self.pub_id}/posts`, {
						params: {
							date: pagination.dataset.date,
							from: pagination.dataset.from,
							view: self.tpl.find('#pubPostViewSelector').val(),
						}
					});
					pagination.dataset.from = parseInt(pagination.dataset.from) + 20;

					if(res.data.html) {
						let container = document.getElementById('posts-container');
						container.insertAdjacentHTML('beforeend', res.data.html );
					} else {
						observer.unobserve(pagination);
					}

					pagination.dataset.loading = false;
				}
			}
		}, options);

		// Observando el elemento button
		let targetElement = self.tpl.find('div[data-posts-loadmore]').get(0);
		if (targetElement instanceof Element) {
			observer.observe(targetElement);
		}

	}

};
